import {
    IconBuilding,
    IconCalendar,
    IconHome,
    IconLayers,
    IconLogout,
    IconShield,
    IconStethoscope,
    IconUser,
    IconUsers,
} from "../../icons/IconsAdmin";
import "./AdminSidebar.css";

const navigationItems = [
    { id: "dashboard", label: "Dashboard", icon: <IconHome /> },
    { id: "servicios", label: "Servicios", icon: <IconLayers /> },
    { id: "medicos", label: "Médicos", icon: <IconStethoscope /> },
    { id: "pacientes", label: "Pacientes", icon: <IconUser /> },
    { id: "turnos", label: "Turnos", icon: <IconCalendar /> },
    { id: "sedes", label: "Sedes", icon: <IconBuilding /> },
    { id: "usuarios", label: "Usuarios", icon: <IconUsers /> },
    { id: "obrasSociales", label: "Obras sociales", icon: <IconShield /> },
    { id: "planes", label: "Planes", icon: <IconLayers /> },
];

const roleLabels = {
    admin: "Administrador",
    recepcionista: "Recepcionista",
    medico: "Médico",
    paciente: "Paciente",
};

const AdminSidebar = ({ currentPage, onNavigate, user, onLogout }) => {
    return (
        <aside className="admin-sidebar">
            <a href="#admin-main-content" className="skip-link">Saltar al contenido principal</a>

            <div className="admin-sidebar__brand">
                <img
                    src="/logo192.png"
                    alt="Logo Sweet Medical"
                    className="admin-sidebar__logo"
                    style={{ width: '40px', height: '40px', objectFit: 'contain' }}
                />

                <div>
                    <strong>Sweet Medical</strong>
                    <span>Admin panel</span>
                </div>
            </div>

            <nav className="admin-sidebar__nav" aria-label="Navegación principal del panel de administración">
                {navigationItems.map((item) => (
                    <button
                        key={item.id}
                        type="button"
                        className={`admin-sidebar__item ${currentPage === item.id ? "admin-sidebar__item--active" : ""}`}
                        onClick={() => onNavigate(item.id)}
                        aria-current={currentPage === item.id ? "page" : undefined}
                    >
                        <span aria-hidden="true">{item.icon}</span>
                        {item.label}
                    </button>
                ))}
            </nav>

            <div className="admin-sidebar__user">
                <div className="admin-sidebar__avatar" aria-hidden="true">{user.displayName?.[0] || "U"}</div>

                <div>
                    <strong>{user.displayName}</strong>
                    <span>{roleLabels[user.role] || user.role}</span>
                </div>
            </div>

            <button className="admin-sidebar__logout" type="button" onClick={onLogout} aria-label="Cerrar sesión">
                <IconLogout aria-hidden="true" />
                <span>Cerrar sesión</span>
            </button>
        </aside>
    );
};

export default AdminSidebar;